import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form } from "shards-react";
import { TiTick, TiTimes } from "react-icons/ti";
import { FcPlus,FcList } from "react-icons/fc";
import UserDataService from "../../services/user.service";
import { ToastContainer, toast } from "react-toastify";
import authStore from "../../_stores/auth.store";

class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetails: {},
    };
  }

  componentDidMount() {
    if (this.props.userId) this.retrieveUserDetails();
  }

  retrieveUserDetails() {
    UserDataService.get(this.props.userId).then((response) => {
      this.setState({
        userDetails: response.data.data,
      });
    });
  }

  render() {
    const {
      userDetails: { _id, name, email, ssoUser, role, projects, active },
    } = this.state;
    const { userId } = this.props;

    return (
      <div className="user-details">
        <Card small className="mb-4">
          <CardHeader className="border-bottom">
            <h6 className="m-0"> User Details
              <Link className="btn btn-primary ml-4" to={"/view-users"}>
                <FcList /> View All
              </Link>
            </h6>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              <Form>
                <Row form>
                  {/* First Name */}
                  <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="name">Name</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            {name}
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="email">Email Id</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            {email}
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="ssoUser">SSO User</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <div className="text-01">
                              {ssoUser ? (
                                <span className="text-primary">
                                  <TiTick />
                                </span>
                              ) : (
                                <span className="text-warning">
                                  <TiTimes />
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="Role">Role</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            {role}
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="Role">Projects</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            {projects && projects.length ? (
                              projects.map((proj, inx) => (
                                <Row key={proj.projectId} className="mb-2">
                                  <Col md="auto">
                                    <div className="text-01">
                                      <span className="text-primary">
                                        <TiTick />
                                      </span>
                                    </div>
                                  </Col>
                                  <Col md="10">
                                    <div className="text-02">{proj.projectName}</div>
                                  </Col>
                                </Row>
                              ))
                            ) : (
                              <>-- --</>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="active">Active</label>
                      </Col>
                      <Col className="" md="8">
                        <Row>
                          <Col className="form-field" md="9">
                            <div className="text-01">
                              {active ? (
                                <span className="text-primary">
                                  <TiTick />
                                </span>
                              ) : (
                                <span className="text-warning">
                                  <TiTimes />
                                </span>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-button" md="4">
                        <Link className="btn btn-primary" data-tip data-for="editTip" to={"/edit-user/" + _id}>
                          <FcPlus /> Edit User
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />
      </div>
    );
  }
}

export default CreateUser;
